'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var reactVirtuoso = require('react-virtuoso');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
var listbox$1 = require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
var refs = require('../../../../utilities/refs.js');
var usePreventKeyboardScrolling = require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
var boxShadow = require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
var list = require('../../../../styles/styled-components/list.js');
var listbox = require('../../../../styles/styled-components/listbox.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var standardOption = require('../../option/standard-option/standard-option.js');
var baseListbox = require('../base-listbox/base-listbox.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const borderWidth = 1;
const height = 250;
const padding = 10;
const BaseStandardListbox = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className , ellipsis , initialSelectedIndex , keyset , look , onSelected , optionProps , options , selectedIndex , virtualized , virtualizedProps , ...otherProps } = props;
    const isVirtualized = virtualized && options.length > 10;
    const listboxRef = React.useRef(null);
    const virtuosoRef = React.useRef(null);
    React.useEffect(()=>{
        if (virtuosoRef.current && selectedIndex !== undefined) {
            /**
         * If you change `scrollToIndex` `behavior`, also change `scroll` `behavior` in `StandardOption`
         */ virtuosoRef.current.scrollToIndex({
                index: selectedIndex,
                align: 'center',
                behavior: 'auto'
            });
        }
    }, [
        selectedIndex
    ]);
    usePreventKeyboardScrolling.usePreventKeyboardScrolling(keyset);
    return /*#__PURE__*/ React__default.default.createElement(baseListbox.BaseListbox, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-listbox__standard': true,
            [`bf-listbox__standard--look-${look}`]: look,
            'bf-listbox__standard--virtualized': isVirtualized,
            [`${className}`]: !!className
        }),
        ref: refs.mergeRefs([
            listboxRef,
            ref
        ])
    }), options.length === 0 ? null : isVirtualized ? /*#__PURE__*/ React__default.default.createElement(reactVirtuoso.Virtuoso, _extends({}, virtualizedProps, {
        className: classnames__default.default({
            'bf-listbox__virtualized': true,
            [`${virtualizedProps?.className}`]: !!virtualizedProps?.className
        }),
        initialTopMostItemIndex: initialSelectedIndex ?? 0,
        itemContent: (index)=>{
            return /*#__PURE__*/ React__default.default.createElement(standardOption.StandardOption, _extends({}, optionProps, {
                ellipsis: ellipsis,
                index: index,
                listboxPadding: padding,
                listboxRef: listboxRef,
                onSelected: onSelected,
                option: options[index],
                selectedIndex: selectedIndex
            }));
        },
        ref: virtuosoRef,
        style: {
            height: height - borderWidth * 2
        },
        totalCount: options.length
    })) : options.map((option, index)=>{
        return /*#__PURE__*/ React__default.default.createElement(standardOption.StandardOption, _extends({}, optionProps, {
            ellipsis: ellipsis,
            index: index,
            listboxPadding: padding,
            listboxRef: listboxRef,
            key: option.key,
            onSelected: onSelected,
            option: option,
            selectedIndex: selectedIndex
        }));
    }));
});
const Listbox = styled__default.default(BaseStandardListbox)`
  ${list.baseListStyle}
  ${boxShadow.boxShadowListboxes}
  ${({ look  })=>listbox.getListboxTheme({
        look
    })}
  ${list.getListVirtualizedCss({
    borderWidth,
    height,
    padding
})}

  &.bf-listbox__standard--virtualized {
    overflow: unset;
    padding: 0;
  }

  .bf-listbox__virtualized {
    > div {
      padding: ${padding}px ${padding}px 0;

      > div > div {
        &:last-child {
          padding-bottom: ${padding}px;
        }
      }
    }
  }
`;
/**
 * A `role="listbox"` is used to identify an element that creates a list
 * from which a user may select one or more static items. It must contain one
 * or more `role="option"` elements.
 *
 * This component provides `<select>` functionality with with more flexibility
 * in styling and in rendering content within each `role="option"`
 * (such as including `<img>` elements).
 *
 * The `role="listbox"` can be virtualized (a.k.a windowing) for better performance
 * with many `role="option"` elements by setting `virtualized` to `true`.
 *
 * https://www.w3.org/TR/wai-aria-1.2/#listbox
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listbox_role
 *
 * @returns React.ForwardRefExoticComponent<StandardListboxProps & React.RefAttributes<HTMLUListElement>>
 */ const StandardListbox = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { look =listbox$1.ListboxLooks.Default , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Listbox, _extends({}, otherProps, {
        look: look,
        ref: ref
    })));
});

exports.BaseStandardListbox = BaseStandardListbox;
exports.StandardListbox = StandardListbox;
//# sourceMappingURL=standard-listbox.js.map
